import { i18n } from 'utils/i18n';
import { isNil } from 'lodash-es';

export function phone(value = '') {
  if (!/^(\+([0-9]){10,12})$/.test(value)) return i18n.t('validation:phone');
  const phoneLength = value.replace(/\D/g, '').length;
  if (phoneLength < 10 || phoneLength > 12)
    return i18n.t('validation:phoneLength');
  return undefined;
}

export function anyPhone(value = '') {
  if (!/^(\+?([0-9]){10,12})$/.test(value)) return i18n.t('validation:phone');
  const phoneLength = value.replace(/\D/g, '').length;
  if (phoneLength < 10 || phoneLength > 12)
    return i18n.t('validation:phoneLength');
  return undefined;
}

export function required(value) {
  if (typeof value === 'string' && value !== '') return;
  if (!isNil(value)) return;
  return i18n.t('validation:required');
}

export function noSpaces(v) {
  return !/\s/.test(v) ? undefined : i18n.t('validation:no_spaces');
}

export function format(re, message) {
  return (v) => (re.test(v) ? undefined : message);
}

export const validateSignInLogin = (v) => required(v) || noSpaces(v);

export function password(value) {
  const error = composeValidation(
    format(/[a-z]/, i18n.t('validation:one_lathin_lowercase_letter')),
    format(/[A-Z]/, i18n.t('validation:one_lathin_uppercase_letter')),
    format(/[0-9]/, i18n.t('validation:one_digit')),
    format(/.{8,}/, i18n.t('validation:more_than_8_length'))
  )(value);
  return error ? i18n.t('validation:password_must', { error }) : undefined;
}

export function composeValidation(...validators) {
  return (...args) => validators.reduce(
      (acc, f) => acc || (typeof f === 'function' ? f(...args) : undefined),
      undefined
    );
}
